import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Dashboard from './pages/Dashboard';
import StockManagement from './pages/StockManagement';
import ScanQRCode from './pages/ScanQRCode';
import UsersList from './pages/UsersList';
import RequestsManagement from './pages/RequestsManagement';
import GeneralQRCode from './pages/GeneralQRCode';
import UserApp from './pages/UserApp';
import PlanifSync from './pages/PlanifSync';
import SimpleScan from './pages/SimpleScan';
import Login from './pages/Login';
import { getPhoneId } from './utils/phoneId';
import { API_URL } from './config/api';

function App() {
  const [phoneId, setPhoneId] = useState(null);
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(null); // null = loading, false = not logged, true = logged

  useEffect(() => {
    const id = getPhoneId();
    setPhoneId(id);

    const identifyUser = async (phoneId) => {
      try {
        const response = await fetch(`${API_URL}/api/users/identify`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ phone_id: phoneId }),
        });
        if (response.ok) {
          const userData = await response.json();
          setUser(userData);
        }
      } catch (error) {
        console.error('Erreur lors de l\'identification:', error);
      }
    };

    if (id) identifyUser(id);

    // Verifier le token admin
    const token = localStorage.getItem('admin_token');
    if (token) {
      fetch(`${API_URL}/api/auth/verify`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token }),
      })
        .then(r => r.json())
        .then(data => setIsAdmin(data.valid === true))
        .catch(() => setIsAdmin(false));
    } else {
      setIsAdmin(false);
    }
  }, []);

  const handleLogin = (token) => {
    setIsAdmin(true);
  };

  const handleLogout = () => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      fetch(`${API_URL}/api/auth/logout`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token }),
      }).catch(() => {});
    }
    localStorage.removeItem('admin_token');
    setIsAdmin(false);
  };

  // Composant wrapper pour les routes admin
  const AdminRoute = ({ children }) => {
    if (isAdmin === null) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#1a1a2e' }}>
          <div style={{ color: 'white', fontSize: '1.2rem' }}>Chargement...</div>
        </div>
      );
    }
    if (!isAdmin) {
      return <Login onLogin={handleLogin} />;
    }
    return (
      <div className="App">
        <Navbar user={user} onLogout={handleLogout} />
        <div className="container">
          {children}
        </div>
      </div>
    );
  };

  return (
    <Router>
      <Routes>
        {/* Routes PUBLIQUES (telephone - pas de login) */}
        <Route path="/user" element={<UserApp />} />
        <Route path="/user/requests" element={<UserApp />} />
        <Route path="/scan" element={<SimpleScan />} />

        {/* Routes ADMIN (protegees par login) */}
        <Route path="/" element={<AdminRoute><Dashboard user={user} phoneId={phoneId} /></AdminRoute>} />
        <Route path="/stock" element={<AdminRoute><StockManagement /></AdminRoute>} />
        <Route path="/scan-admin" element={<AdminRoute><ScanQRCode phoneId={phoneId} user={user} /></AdminRoute>} />
        <Route path="/requests" element={<AdminRoute><RequestsManagement /></AdminRoute>} />
        <Route path="/qrcode-general" element={<AdminRoute><GeneralQRCode /></AdminRoute>} />
        <Route path="/users" element={<AdminRoute><UsersList /></AdminRoute>} />
        <Route path="/planif-sync" element={<AdminRoute><PlanifSync /></AdminRoute>} />
        <Route path="/login" element={
          isAdmin ? <Navigate to="/" replace /> : <Login onLogin={handleLogin} />
        } />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
